module.exports = __webpack_public_path__ + "static/media/avatar@2x.db284d95.jpg";